import api from "@/lib/axios";

export const noteService = {
  // Get all forms

  // Create a new 
  createNotes: async (payload) => {
    try {
      const response = await api.post("/note-categories", payload);
      return response.data;
    } catch (error) {
      throw new Error("Failed to create notes: " + error.message);
    }
  },

  fetchNotes: async () => {
    try {
      const response = await api.get("/note-categories");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch notes: " + error.message);
    }
  },
  
  // Update an existing note
  updateNote: async (noteId, payload) => {
    try {
      const response = await api.put(`/note-categories/${noteId}`, payload);
      return response.data;
    } catch (error) {
      throw new Error("Failed to update note: " + error.message);
    }
  },

  // Delete a note
  deleteNote: async (noteId) => {
    try {
      const response = await api.delete(`/note-categories/${noteId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to delete note: " + error.message);
    }
  }
};

  

